import { View } from 'foundations-components/components/View';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useEffect, useState } from 'react';
import { trackAdditionalUnitsPicker, trackTooltipInteraction } from '../../utils/tracking/trackingEventUtils';
import { isValidApiName } from '../../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function AddOnQuantityStepper({
  productApiName,
  quantity,
  onQuantityChange,
  disabled = false,
  trackingSource,
  productDetails,
  ownedQuantity,
  stepSize = 1
}) {
  var _productDetails$quant, _productDetails$maxTo;
  const [displayedValue, setDisplayedValue] = useState(0);
  const [hasStepperBeenClicked, setHasStepperBeenClicked] = useState(false);
  const quantifiable = (_productDetails$quant = productDetails === null || productDetails === void 0 ? void 0 : productDetails.quantifiable) !== null && _productDetails$quant !== void 0 ? _productDetails$quant : false;
  const maxTouchlessPurchasableQuantity = (_productDetails$maxTo = productDetails === null || productDetails === void 0 ? void 0 : productDetails.maxTouchlessPurchasableQuantity) !== null && _productDetails$maxTo !== void 0 ? _productDetails$maxTo : null;
  const maxValue = maxTouchlessPurchasableQuantity === null || maxTouchlessPurchasableQuantity === undefined ? Infinity : stepSize * maxTouchlessPurchasableQuantity;
  const ownsMaxQuantityOfProduct = maxTouchlessPurchasableQuantity !== null && ownedQuantity >= maxTouchlessPurchasableQuantity;
  const ownsProduct = ownedQuantity > 0;
  const canBuyMultiple = quantifiable && (maxValue > stepSize || maxValue === Infinity);
  useEffect(() => {
    if (hasStepperBeenClicked) {
      setDisplayedValue(quantity * stepSize);
    }
  }, [quantity, stepSize, hasStepperBeenClicked]);
  const handleStepperChange = evt => {
    var _productDetails$skuId;
    const newQuantity = Math.round(parseInt(evt.target.value, 10) / stepSize);
    if (isNaN(newQuantity)) return;
    setHasStepperBeenClicked(true);
    setDisplayedValue(newQuantity * stepSize);
    const direction = newQuantity > quantity ? 'increase' : 'decrease';
    trackAdditionalUnitsPicker({
      trackingSource,
      action: `stepper ${direction}`,
      ownedUnitQuantity: ownedQuantity !== null && ownedQuantity !== void 0 ? ownedQuantity : 0,
      displayedUnitQuantity: newQuantity * stepSize,
      productName: productApiName,
      skuId: (_productDetails$skuId = productDetails === null || productDetails === void 0 ? void 0 : productDetails.skuId) !== null && _productDetails$skuId !== void 0 ? _productDetails$skuId : 0,
      ownsProduct
    });
    onQuantityChange(newQuantity);
  };
  if (!canBuyMultiple) {
    return null;
  }
  const disabledMinButtonTooltipKey = 'pricingPage.pages.addOns.cards.addOns.tooltip';
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text(`pricing-pages-ui.productNamesV2.${productApiName}.title`),
    children: /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(StepperInput, {
        "data-selenium-id": `${trackingSource}-${productApiName}-stepper-input`,
        disabled: disabled || ownsMaxQuantityOfProduct,
        disabledMinButtonTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: disabledMinButtonTooltipKey
        }),
        disabledMinButtonTooltipProps: {
          onOpenChange: e => {
            if (e.currentTarget.value) {
              trackTooltipInteraction({
                action: 'hovered',
                name: `${trackingSource}-${productApiName}-stepper-input-disabled-tooltip`,
                value: getI18nText(disabledMinButtonTooltipKey, {
                  locale: 'en-us'
                }),
                trackingSource,
                productName: isValidApiName(productApiName) ? productApiName : undefined
              });
            }
          },
          children: /*#__PURE__*/_jsx(_Fragment, {})
        },
        stepSize: stepSize,
        onChange: handleStepperChange,
        value: displayedValue,
        min: 0,
        max: maxValue,
        inlineSize: '107px'
      })
    })
  });
}